export const DEFAULT_VALUES = {
  PartyType: 'Person',
  ptsPartyID: null,
  PartyRelationship: '',
  PriorityOrder: 0,
  AdvisoryText: '',
};
